
export default function initTabs() {
    const $blocksTabs = document.querySelectorAll<HTMLElement>('.js-tabs');
    $blocksTabs.forEach($container => {
        new Tabs($container);
    });
}

/**
 * @param {HTMLElement} $el           HTML Element Block nos offres
 */
class Tabs {
    $el: HTMLElement | null | undefined;
    $tabs: NodeListOf<HTMLElement> | null | undefined;
    $tabsButtons: NodeListOf<HTMLElement> | null | undefined;
    
    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$tabs = $el?.querySelectorAll('[data-tab]');
        this.$tabsButtons = $el?.querySelectorAll('[data-tab-target]');

        this.init();
    }

    /**
     * Initialise les onglets
     */
    init() : void {
        this.$tabsButtons?.forEach((button) => {
            const activeButtonDataTarget = button.getAttribute('data-tab-target');
            button.addEventListener('click', ()=> {
                if (!button.classList.contains('active')) {
                    this.$tabsButtons?.forEach(button => button.classList.remove('active'))
                    button.classList.add('active');
                }

                this.$tabs?.forEach((tab) => {
                    if(activeButtonDataTarget === tab.getAttribute('data-tab')) {
                        this.$tabs?.forEach(tab => tab.classList.remove('active'));
                        tab.classList.add('active');
                    }
                })
            })
        })
    }
}
